<script>
  export let imgSrc;
  export let alt = "";
  export let size = "100%";     // t.ex. "120px" eller "100%"
  export let circle = true;     // gör bilden rund
  export let playing = false;   // kan styras direkt

  let imgEl;
  let clickedWhileStopping = false;

  // Samma API som du har i PlayLPSVG (för kompatibilitet med App.svelte)
  export const isAnimating = (ply) => async () => {
    if (ply) {
      clickedWhileStopping = true;
      startRotationFromCurrent(imgEl, 40, 160, "cw"); // lång “nästan-infinite”
    } else {
      clickedWhileStopping = false;
      setTimeout(() => {
        if (!clickedWhileStopping) freezeRotationAtCurrent(imgEl);
      }, 100);
    }
  };

  // Om du hellre vill styra med prop: playing
  $: if (imgEl) {
    if (playing) {
      const exec = isAnimating(true);
      exec();
    } else {
      const exec = isAnimating(false);
      exec();
    }
  }

  function startRotationFromCurrent(el, turns = 1, duration = 4, direction = "cw") {
    if (!el) return;

    const computed = getComputedStyle(el);
    const matrix = computed.transform;

    // Om ingen transform finns än
    if (!matrix || matrix === "none") {
      el.style.transform = "rotate(0deg)";
      requestAnimationFrame(() => {
        el.style.transition = `transform ${duration}s linear`;
        const delta = direction === "ccw" ? -360 * turns : 360 * turns;
        el.style.transform = `rotate(${delta}deg)`;
      });
      return;
    }

    const values = matrix.match(/matrix\(([^)]+)\)/)?.[1]?.split(",").map(parseFloat);
    if (!values || values.length < 6) return;

    const angle = Math.atan2(values[1], values[0]) * (180 / Math.PI);
    const currentDeg = (angle + 360) % 360;
    const delta = direction === "ccw" ? -360 * turns : 360 * turns;

    el.style.animation = "none";
    el.style.transition = "none";
    el.style.transform = `rotate(${currentDeg}deg)`;

    requestAnimationFrame(() => {
      el.style.transition = `transform ${duration}s linear`;
      el.style.transform = `rotate(${currentDeg + delta}deg)`;
    });
  }

  function freezeRotationAtCurrent(el) {
    if (!el) return;

    const computed = getComputedStyle(el);
    const matrix = computed.transform;
    if (!matrix || matrix === "none") return;

    const values = matrix.match(/matrix\(([^)]+)\)/)?.[1]?.split(",").map(parseFloat);
    if (!values || values.length < 6) return;

    const angle = Math.atan2(values[1], values[0]) * (180 / Math.PI);
    const currentDeg = (angle + 360) % 360;

    el.style.animation = "none";
    el.style.transition = "none";
    el.style.transform = `rotate(${currentDeg}deg)`;
  }
</script>

<div class="coverWrap" style:width={size} style:height={size}>
  <img
    bind:this={imgEl}
    class:circle
    class="coverImg"
    src={imgSrc}
    {alt}
    draggable="false"
    on:error={(e) => (e.currentTarget.style.display = "none")}
  />
</div>

<style>
  .coverWrap {
    position: relative;
    display: inline-block;
    aspect-ratio: 1;
  }

  .coverImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform-origin: center center;
    user-select: none;
    -webkit-user-drag: none;
    will-change: transform;
  }

  .circle {
    border-radius: 9999px;
  }
</style>